<template>
    <main role="main">
        <article class="layout-contents-container">
            <settings-header menu="3"></settings-header>
            <div class="layout-contents">
                <div class="tbl-header">
                    <div class="inner">
                        <h2 class="title">
                            {{$t('SETTING.REGION.HEADER.TITLE')}}
                        </h2>
                        <p class="desc">{{$t('SETTING.REGION.HEADER.DESC')}}</p>
                        <p class="desc">{{$t('SETTING.REGION.HEADER.DETAILS')}}</p>
                    </div>
                </div>
                <div class="custom-container mt-4">
                    <div >
                        <div style="width : 450px; display: inline-block;">
                            <GroupSelect 
                                id="all-region"
                                :options="preSlctedOption"
                                :callGetValue="getPreSlctedValue"
                                :preSlctedValue="preSlctedValue"
                                :headTitle="$t('SETTING.REGION.HEADER.ALL_REGION')"
                                height="400px"
                                :countSelect="false"
                                :isLoading="isLoading"
                                key="all-region"
                            />
                        </div>
                        <div style="width : 50px; display: inline-block;">
                            <button class="-btn primary- icon-only-" type="button" style="margin: 8px" @click="backSelectRegion()" v-bind:Disabled="isDisabledBack">
                                <span class="material-icons">chevron_right</span>
                            </button>
                            <button class="-btn primary- icon-only-" type="button" style="margin: 8px" @click="forwarkSelectRegion()" v-bind:Disabled="isDisabledForwark">
                                <span class="material-icons">chevron_left</span>
                            </button>
                        </div>
                        <div style="width : 450px;display: inline-block;">
                            <GroupSelect 
                                id="selected-region"
                                :options="treeOptions"
                                :callGetValue="callGetValue"
                                :preSlctedValue="treeSlctedValue"
                                :headTitle="$t('SETTING.REGION.HEADER.EXCLUSION_REGION')"
                                height="400px"
                                :countSelect="false"
                                :isLoading="isLoading"
                                key="selected-region"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-panel">
                <button type="button" class="-btn primary- -btn-ok"
                    data-type="key"
                    data-size="l"
                    :disabled="listModify.length == 0"
                    @click="openModal"
                >
                    {{ $t('COMMON.BUTTON.CAMEL.OK')}}
                </button>
                <button type="button" class="btn btn-light"
                    data-type="key"
                    data-size="l"
                    @click="resetSelectRegion()"
                >
                    {{ $t('COMMON.BUTTON.CAMEL.CANCEL')}}
                </button>
            </div>
            <Modal
                :title="modal.popupTitle"
                :message="modal.popupMessage"
                :isShowPopup="modal.isShowPopup"
                :callOnHide="handleHideModal"
                :okFunction="saveSlctRegion"
            />
            <div-loading v-if="loading" :full="true"></div-loading>
        </article>
    </main>
</template>

<script>
import TreeSelect from "../common/TreeSelect.vue";
import settingsHeader from "./settingsHeader.vue";
import Modal from "../common/Modals/Modal.vue";
import {mapGetters} from "vuex";
import { EventBus } from "../common/event-bus";
import GroupSelect from '../common/GroupSelect/GroupSelect.vue';

export default {
    name: "SettingsRegion",
    components: {TreeSelect, settingsHeader, Modal, GroupSelect},
    data() {
        return {
            loading: false,
            regionSetting: [],
            modal: {
                isShowPopup: false
            },
            treeOptions: [],
            treeSlctedValue: [],
            treeValue: [],
            preSlctedOption: [],
            preSlctedValue: [],
            selectedValue: [],
            rootTreeRegion: [],
            isDisabledForwark: true,
            isDisabledBack: true,
            isLoading: false,
            listModify: []
        }
    },
    mounted() {
        this.getRegions();
    },
    computed: {
        ...mapGetters({
            curCmpnId: 'user/curCmpnId'
        }),
    },
    methods: {
        forwarkSelectRegion() {
            let preselectedOption = _.cloneDeep(this.preSlctedOption);
            let treeOptions = _.cloneDeep(this.treeOptions);

            this.treeOptions.forEach((e, i) => {
                (e.children || []).forEach((item) =>{
                    let index = this.treeValue.indexOf(item.id);
                    if (index !== -1){
                        preselectedOption[i].children.push(item);
                        let idx = _.findIndex(treeOptions[i].children, function(o) { return o.id == item.id; });
                        treeOptions[i].children.splice(idx, 1);
                    }
                });
            });

            this.preSlctedOption = preselectedOption;
            this.treeOptions = treeOptions;

            this.isDisabledForwark = true;
            this.treeSlctedValue = [];
            this.treeValue.forEach(item => {
                let idx = _.indexOf(this.listModify, item);
                if (idx !== -1) {
                    this.listModify.splice(idx, 1);
                } else {
                    this.listModify.push(item);
                }
            });
            
        },
        backSelectRegion() {
            let preselectedOption = _.cloneDeep(this.preSlctedOption);
            let treeOptions = _.cloneDeep(this.treeOptions);

            this.preSlctedOption.forEach((e, i) => {
                (e.children || []).forEach((item) =>{
                    let index = this.selectedValue.indexOf(item.id);
                    if (index !== -1){
                        let idx = _.findIndex(preselectedOption[i].children, function(o) { return o.id == item.id; });
                        preselectedOption[i].children.splice(idx, 1);
                        treeOptions[i].children.push(item);
                    }
                });
            });

            this.preSlctedOption = preselectedOption;
            this.treeOptions = treeOptions;

            this.isDisabledBack = true;
            this.preSlctedValue = [];
            this.selectedValue.forEach(item => {
                let idx = _.indexOf(this.listModify, item);
                if (idx !== -1) {
                    this.listModify.splice(idx, 1);
                } else {
                    this.listModify.push(item);
                }
            });
        },
        getRegionUpdate() {
            const rgnUpdate = [];
            const self = this;
            let listSelected = [];
            this.preSlctedOption.forEach(e => {
                listSelected = listSelected.concat(e.children);
            });
            this.regionSetting.forEach((region)=>{
                const rgn = {
                    vendor: region.vendor,
                    rgnId: region.rgnId,
                    selected: 'N'
                };
                if (_.findIndex(listSelected, (o)=> { return o.id == region.rgnId; }) !== -1) {
                    rgn.selected = 'Y';
                }
                rgnUpdate.push(rgn);
            });
            return rgnUpdate;
        },
        createTreeValues(regions) {
            this.regionSetting = regions;
            let vendors = regions.map(item=>{return item.vendor});
            vendors = _.union(vendors);
            const tree = [];
            const treeSelect = [];
            const treePre = [];
            vendors.forEach((vendor)=>{
                let children = [];
                let childrenSelect = [];
                let childrenPre = [];
                regions.forEach(e => {
                    if (e.vendor === vendor) {
                        children.push({id: e.rgnId, label: e.rgnNm});
                        if (e.selected !== 'Y') {
                            childrenSelect.push({id: e.rgnId, label: e.rgnNm});
                        } else {
                            childrenPre.push({id: e.rgnId, label: e.rgnNm});
                        }
                    }
                });

                tree.push({id: vendor, label: this.Common.getShortName(vendor), children});
                treeSelect.push({id: vendor, label: this.Common.getShortName(vendor), children: childrenSelect});
                treePre.push({id: vendor, label: this.Common.getShortName(vendor), children: childrenPre});
            });
            this.treeOptions = treeSelect;
            this.preSlctedOption = treePre;
            this.rootTreeRegion = tree;
        },
        async getRegions() {
            this.isLoading = true;
            const url = "/api/governance/setting/region";
            const header = {
                "cmpnId": this.curCmpnId,
            };
            try {
                const response = await this.http.post(url, JSON.stringify(header));
                if (response.data.status === 'ok') {
                    this.createTreeValues(response.data.result);
                }
            } catch(err) {
                console.error("getRegions: ", err);
            } finally {
                this.pending = false;
                this.isLoading = false;
            }
        },
        handleHideModal() {
            this.modal = {
                isShowPopup: false
            }
        },
        callGetValue(value) {
            this.treeValue = value;
            if (value.length > 0){
                this.isDisabledForwark = false;
            } else {
                this.isDisabledForwark = true;
            }
        },
        getPreSlctedValue(value) {
            this.selectedValue = value;
            if (value.length > 0){
                this.isDisabledBack = false;
            } else {
                this.isDisabledBack = true;
            }
        },
        resetSelectRegion() {
            this.createTreeValues(this.regionSetting);
            this.listModify = [];
        },
        openModal() {
            this.modal = {
                isShowPopup: true,
                popupTitle: this.$t('SETTING.REGION.POPUP.TITLE'),
                popupMessage: this.$t('SETTING.REGION.POPUP.DESC')
            }
        },
        async saveSlctRegion() {
            const regions = this.getRegionUpdate()
            const url = "/api/governance/setting/region/change";
            const header = {
                cmpnId: this.curCmpnId,
                regions
            };
            let isUpdateFail = false;
            try {
                await this.http.post(url, JSON.stringify(header));
            } catch(err) {
                console.error("Update regions error: ", err);
                isUpdateFail = true;
            } finally {
                this.loading = false;
                if (isUpdateFail) {
                    EventBus.$emit('toastComment', 'SETTING.WHITELIST.TOAST.UPDATE_REGION_FAIL');    
                } else {
                    EventBus.$emit('toastComment', 'SETTING.WHITELIST.TOAST.UPDATE_REGION_SUCCESS');
                }
            }
        },
    }
}
</script>

<style lang="css" scoped>
.layout-contents {
    background-color: #FFFFFF;
    padding-left:30px ;
}
.custom-container {
    display:inline
}
.left-panel {
    width: 60%;
    display: inline-block;
}
.right-panel {
    width: 100%;
    display: block;
    margin-left: 0;
    border-top: 1px solid #d3d8e0!important;
    background-color: #FFFFFF;
    height: 46px;
}
.right-panel button {
    float: right;
    margin: 7px 0;
}
.layout-contents-container .layout-contents {
    padding-bottom: 40px;
}
.tbl-header {
    border: none;
    padding: 0;
}
.right-panel .-btn-ok {
    margin-right: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/SettingsRegion.vue